// eslint-disable-next-line import/named
import { ExternalAttendee } from '../model';
import { axiosManager } from '../config';
import { onNextPage } from '../utils';

export interface ISearchExternalAttendeesParameters {
  email?: string;
  name?: string;
  corporation?: string;
  globalSearch?: string;
  page?: string;
  size?: number;
}

export const ExternalAttendeesService = {
  path: 'external_attendees',

  postExternalAttendee(payload: ExternalAttendee): Promise<ExternalAttendee> {
    const url = `${this.path}`;

    return axiosManager
      .getInstance()
      .post(url, payload)
      .then((res) => res.data);
  },

  getExternalAttendeesWithPagination(options: ISearchExternalAttendeesParameters): Promise<{
    data: ExternalAttendee[];
    nextPage: string;
  }> {
    const params = this.createSearchExternalAttendeesParams(options);
    const page = params?.get('page');

    if (page) {
      return axiosManager.getInstance().get(page).then(onNextPage);
    }

    const url = `${this.path}`;

    return axiosManager.getInstance().get(url, { params }).then(onNextPage);
  },

  createSearchExternalAttendeesParams(options: ISearchExternalAttendeesParameters): URLSearchParams {
    const params = new URLSearchParams();

    if (options.email) {
      params.append('email', options.email);
    }

    if (options.name) {
      params.append('name', options.name);
    }

    if (options.corporation) {
      params.append('corporation', options.corporation);
    }

    if (options.globalSearch) {
      params.append('globalSearch', options.globalSearch);
    }

    if (options.page) {
      params.append('page', options.page);
    }

    if (options.size) {
      params.append('size', options.size.toString());
    }

    return params;
  },
};
